function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.00781 1.03125C1.69531 0.34375 2.52344 0 3.49219 0C4.46094 0 5.28125 0.34375 5.95312 1.03125C6.64062 1.70312 6.98438 2.52344 6.98438 3.49219C6.98438 4.66406 6.48438 5.61719 5.48438 6.35156V7.5C5.48438 7.64062 5.4375 7.75781 5.34375 7.85156C5.25 7.94531 5.13281 7.99219 4.99219 7.99219H1.99219C1.85156 7.99219 1.73438 7.94531 1.64062 7.85156C1.54688 7.75781 1.5 7.64062 1.5 7.5V6.35156C0.5 5.66406 0 4.71094 0 3.49219C0 2.52344 0.335938 1.70312 1.00781 1.03125ZM1.99219 9.49219V9H4.99219V9.49219C4.99219 9.63281 4.94531 9.75 4.85156 9.84375C4.75781 9.9375 4.64062 9.98438 4.5 9.98438H2.48438C2.34375 9.98438 2.22656 9.9375 2.13281 9.84375C2.03906 9.75 1.99219 9.63281 1.99219 9.49219Z",
  className: "color-stroke"
});
function SvgIcnBulb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBulb2);
export default __webpack_public_path__ + "static/media/icn-bulb2.ca8ae44faf65c0a14ae4f5047dcf8172.svg";
export { ForwardRef as ReactComponent };